
/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

let BaseHost = "api.lucidtactics.com"
let BaseScheme = "https"
let BaseUrl = "https://api.lucidtactics.com/"
if(!window.location.hostname.includes(".com")) {
    BaseUrl = /*"https://api.lucidtactics.com/" //*/ ""
    BaseHost = window.location.host
    BaseScheme = window.location.protocol.replace(/:/g, '')
} else if (window.location.hostname.includes("staging")){
    BaseHost = "staging-api.lucidtactics.com"
    BaseUrl = "https://staging-api.lucidtactics.com/"
}


export {BaseUrl, BaseScheme, BaseHost}
